export const addSelectedDocument = 'documents/add'
export const removeSelectedDocument = 'documents/remove'
export const setCurrentFolder = 'documents/setFolder'

export const resetDragCounter = 'documents/resetDragCounter'
export const increaseDocumentDragCounter = 'documents/increaseDocumentDragCounter'
export const decreaseDocumentDragCounter = 'documents/decreaseDocumentDragCounter'
export const increaseFileDragCounter = 'documents/increaseFileDragCounter'
export const decreaseFileDragCounter = 'documents/decreaseFileDragCounter'
